namespace $.$$ {
	export class $bog_bzrl_app_filter extends $.$bog_bzrl_app_filter {}
}
